import { render } from "./CookieView.vue?vue&type=template&id=adc9871e"
import script from "./CookieView.vue?vue&type=script&lang=js"
export * from "./CookieView.vue?vue&type=script&lang=js"

import "./CookieView.vue?vue&type=style&index=0&id=adc9871e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__